import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'country'

export default function CountryPage() {
  const submit = useSubmit()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value') || ''
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const country = formData.get('value') as string

    if (!country.trim()) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Which country do you live in?',
      answer_key: country.toLowerCase(),
      answer: country,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <TextInputPage
      heading="pages.onboarding.country.heading"
      description="pages.onboarding.country.description"
      placeholder="pages.onboarding.country.placeholder"
      onSubmit={handleSubmit}
      value={value}
    />
  )
}
